import React from "react";
import { ScreenNameList } from "@lib/utilities/Constants";
import { withPolicyDataFetching } from "../../hoc/withFetchPolicyData";
import { useMakeClaim } from "@lib/hooks/claim/useMakeClaim";
import PageWrapper from "../../components/common/PageWrapper";
import ClaimContentView from "../../components/makeClaim/ClaimContentView";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Platform } from "react-native";
import MainContainer from "../../components/common/MainContainer";

const MakeClaim = ({ navigation }: any) => {
  const {
    policyList,
    loading,
    policyNumber,
    onReloadPress,
    errorData,
    onEndTimer,
  } = useMakeClaim();

  return (
    <MainContainer
      screenName={ScreenNameList.makeClaim}
      navigation={navigation}
      errorData={errorData}
      onReloadPress={onReloadPress}
      onEndTimer={onEndTimer}
    >
      <PageWrapper
        screenName={ScreenNameList.makeClaim}
        navigation={navigation}
        isLoading={loading}
        arrayPolicyList={policyList}
      >
        {!loading && policyNumber != "" ? <ClaimContentView /> : <></>}
      </PageWrapper>
    </MainContainer>
  );
};

export default Platform.OS=='web'? withAuthenticationRequired(withPolicyDataFetching(MakeClaim)):withPolicyDataFetching(MakeClaim);
